import Heading from "csi/def/Heading";
import { Renderer } from "csi/heading/Renderer";
import { GetOptionsProps, InlinePopupGetOptionsFunction, InlinePopupProps } from "csi/middleware/inline/InlinePopup";
import { routerStore } from "csi/state/rootStore";
import { ComponentItem } from "designSystem/types/component-item-types";
import { SyntheticEvent } from "react";
import { isPinyinEnabled } from "src/c8-platform/service/languageService";

export const CONTROL_TYPE_SINGLE_SELECT = "csi/middleware/inline/InlineSingleSelect";
export const CONTROL_TYPE_MULTI_SELECT = "csi/middleware/inline/InlineMultiSelect";
export const CONTROL_TYPE_TEXT_FIELD = "csi/middleware/inline/InlineTextField";

/** open inline popup */
export function openInlinePopup(
	onCancel: VoidFunction,
	onChange: (ev: SyntheticEvent, val: ComponentItem) => void,
	onDialogClose: VoidFunction,
	onLastInputChange: (value: string) => void,
	refNode: HTMLElement,
	heading: Heading,
	ren: Renderer,
	getOptions: InlinePopupGetOptionsFunction,
	placeholderOptions: GetOptionsProps,
	required: boolean,
	controlType: "MultiSelect" | "SingleSelect",
	dropdownOpen: boolean,
): void {
	const inlinePopupProps: InlinePopupProps = {
		allowPinyin: isPinyinEnabled(),
		onDialogClose,
		getOptions,
		onCancel,
		onChange,
		onLastInputChange,
		dropdownOpen,
		placeholderOptions,
		refNode,
		heading,
		ren,
		required,
		controlType,
	};
	routerStore.openInlineDialog("csi/middleware/inline/InlinePopup", inlinePopupProps);
}

/** close popup */
export function closeInlinePopup(): void {
	routerStore.closeInlineDialog();
}